export default __webpack_public_path__ + "static/media/aboutDeepak1.317b4a04.jpeg";